import { Alert, Color, Flex, ProgressBar, Spacing, Text } from '@billy/design-system'
import isNumber from 'lodash/isNumber'
import { ReactElement, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocalStorage } from 'react-use'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { LocalStorageKeys } from '../../../../../../enums/localStorageKeys'
import { useSegment } from '../../../../../../hooks'
import { getClassName } from '../../../../../../utils/getClassName'
import { useExternalInvoicesSyncProgress } from '../../contexts/externalInvoicesSyncProgressContext'
import * as Styled from './styles'

export const SyncProgressTopBar = (): ReactElement | null => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { organization } = useUserOrganization()
  const { processedDocumentsCount, progressPercent, totalDocumentsCount } = useExternalInvoicesSyncProgress()
  const [isTopBarClosed, setIsTopBarClosed] = useLocalStorage<boolean | undefined>(
    `${LocalStorageKeys.HideExternalInvoicesSyncProgressTopBar}-${organization?.id}`,
  )

  useEffect(() => {
    if (!isTopBarClosed) {
      track('xxx-sales-HistoricalSync-Top Bar updated', {
        topBarType: 'in progress',
      })
    }
  }, [isTopBarClosed, track])

  const handleTopBarClose = useCallback(() => setIsTopBarClosed(true), [setIsTopBarClosed])

  if (isTopBarClosed) {
    return null
  }

  return (
    <Alert
      className={getClassName('dark-theme-suspend')}
      closable
      icon="refresh"
      onClose={handleTopBarClose}
      variant="info"
    >
      <Flex alignItems="center" gap={Spacing.S16}>
        <Text>{t('external_invoices_sync_top_bar.in_progress.syncing_in_progress')}</Text>
        <Styled.ProgressBarWrapper>
          <ProgressBar
            backgroundColor={Color.Grey100}
            progress={progressPercent}
            progressColor={Color.Purple700}
            size="small"
          />
        </Styled.ProgressBarWrapper>
        {isNumber(processedDocumentsCount) && isNumber(totalDocumentsCount) && (
          <Text color={Color.Purple700} variant="bodySM">
            {t('external_invoices_sync_top_bar.in_progress.documents_out_of_total', {
              processedDocumentsCount,
              totalDocumentsCount,
            })}
          </Text>
        )}
      </Flex>
    </Alert>
  )
}
